var $ = require('jquery');
import Mustache from 'mustache';

export function machineSearch(form) {
  //need to send language, get from html lang attr.
  let language = document.documentElement.lang;
  let formData = $(form).serialize();
  formData = formData + '&language=' + language;

  //get elements to pass into subfunctions
  const formElems = $('.activate-warranty__forms');

  //get response
  $.ajax({
    type: 'get',
    url: '/stage-ajax/get-serialnumber/',
    data: formData,
    cache: false,
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    error: function(err) {
      console.log(err);
    },
    success: function(response) {
      if(response.status==="success"){
        //start showing machine information
        showSerial(response.data, formElems);
      } else {
        //SHOW ERROR - users needs this info
        showError(response, formElems);
      }
    }
  });
}

/*
  Shows the machine information
  {data} - object
*/
function showSerial(data, formElems){
  const resultTemplate = formElems.parents('.activate-warranty').find('.mustache-machine-result');

  // contruct these when there is more time
  let serialElement = formElems.find('.serial-number-found');
  let resultElement = formElems.find('.serial-number-found__txt');
  let serialErrorTxt = formElems.find('.serial-search-error');
  let machineInput = formElems.find('#machineId');
  let commissionReport = formElems.find('.commission-report');

  const isActivated = data.warranty_activated && data.warranty_activated !== "0";

  //we found some data eh? Lets show it.
  serialElement.show();
  resultElement.show();

  //clear previous error text and hide the element
  serialErrorTxt.hide();
  serialErrorTxt.text('');

  //collect data into text ( arms, clamps and pads (option: 4th jaw) )
  let armClampPadTxt =  ( data._arms !== null ? data._arms : '' )
                          + ( data._clamps !== null ? ', ' + data._clamps : '' )
                          + ( data._pads !== null ? ', ' + data._pads : '' )
                          + ( data.jaw !== 0 ? ', 4th jaw ' : '' );

  //show collected txt
  const mustacheParams = {
    serial: data.serial_number,
    model: data.model + ' ' + data.equipment,
    armClampPad: armClampPadTxt,
    isActivated
  };

  const resultContent = Mustache.render(resultTemplate.html() , mustacheParams );
  resultElement.html(resultContent);

  //if file does not exist, show file upload form
  if(!isActivated) {
    //update machineInput
    machineInput.val(data.uuid);
    commissionReport.show();
  } else {
    commissionReport.hide();
  }
}

/*
  Shows the machine search error
  {response} - object
*/
function showError(response, formElems){
  // contruct these when there is more time
  let serialElement = formElems.find('.serial-number-found');
  let serialErrorTxt = formElems.find('.serial-search-error');
  let machineInput = formElems.find('#machineId');
  let commissionReport = formElems.find('.commission-report');

  //show the machine info element
  serialElement.show();
  //hide other elements
  serialElement.find('.serial-number-found-txt').hide();

  //show error text
  serialErrorTxt.text(response.message);
  serialErrorTxt.show();

  //clear machineInput so we don't let wrong machine get files
  machineInput.val();
  commissionReport.hide();
}

export default function init() {
  if( $('form.machine-search').length > 0 ) {
    //prevent form submit
    $('form.machine-search').on('submit', function (e) {
      e.preventDefault();
      machineSearch(this);
    });
  }
}
